import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { required, isPositive } from '@utils/validators';

import {
  RemoteAutoComplete,
  RemoteAutoCompleteField,
  Input,
  InputField,
  NumberSequence,
  FormattedNumberInput
} from '@components/form';
import { floatOnly, formatToDecimals } from '@utils/utils';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6}>
          <NumberSequence
            inputName={'number'}
            label={'Číslo artiklu *'}
            formName={'InventoryCardsGrid'}
            sequenceKey={'sequenceInventoryCard'}
            inputProps={{ disabled: true }}
            validate={[required]}
          />
        </Col>
        <Col md={6} key={name}>
          <InputField
            component={FormattedNumberInput}
            id={'unitPrice'}
            name={'unitPrice'}
            label={'Jednotková cena s DPH *'}
            validate={[required, isPositive]}
            normalize={floatOnly}
            format={v => formatToDecimals(v)}
          />
        </Col>

        {[
          { name: 'measureUnit', label: 'Měrná jednotka *', url: '/metropolis/api/wa/measure-units' },
          { name: 'category', label: 'Kategorie *', url: '/metropolis/api/wa/cardCategories' }
        ].map(({ name, label, url }) => (
          <Col md={6} key={name}>
            <RemoteAutoCompleteField
              component={RemoteAutoComplete}
              label={label}
              name={name}
              id={name}
              url={url}
              filterActive={true}
              fullWidth={true}
              labelFunction={o => get(o, 'name')}
              validate={[required]}
            />
          </Col>
        ))}
        <Col md={12}>
          <InputField
            component={Input}
            multiLine={true}
            name="description"
            id="description"
            label={'Popis'}
            style={{ maxHeight: '60vh' }}
            inputStyle={{ maxHeight: '60vh' }}
            textareaStyle={{ maxHeight: '56vh' }}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);
export const InventoryCardsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/inventoryCards/InventoryCardsFormBasic.tsx